import type { ReactNode } from 'react';
import { ABSOLUTE_FILL } from '../helpers';
import { AnimatePresence } from 'framer-motion';
import { useCalculateDims } from './section-container.hooks';
import type { FastLaneSection } from '../types';
import { usePlayColorRush } from './color-rush.hooks';

function ColorRushContainer({ children, lastEntry }: { children: ReactNode, lastEntry: FastLaneSection }) {
  const { left, width } = useCalculateDims(lastEntry);
  const showColorRush = usePlayColorRush();
  const rightOfEntries = left + width;

  return (
    <div
      style={{
        ...ABSOLUTE_FILL,
        background: '#000',
        width: rightOfEntries,
      }}
    >
      <AnimatePresence>
        {
          showColorRush && children
        }
      </AnimatePresence>
    </div>
  );
}

export default ColorRushContainer;
